import {
  Asset,
  AssetType,
  CTAStyles,
  SportType,
  WheelTheme,
} from '@longnecktech/splash-commons-fe';

export function asset(name: string): Asset {
  return {
    uuid: name,
    createdTs: '',
    name,
    label: name,
    comment: '',
    url: `/assets/store/${name}`,
    tags: [],
    type: AssetType.GAME,
    sportType: SportType.OTHER,
  };
}

function values(entries: Record<string, string>) {
  return Object.entries(entries).map(([key, value]) => ({
    uuid: key,
    key,
    value,
    description: '',
    hint: '',
  }));
}

const font = (weight: string): Asset => ({
  ...asset(weight),
  url: `/assets/fonts/Roboto_Condensed/RobotoCondensed-${weight}.ttf`,
});

export const luckyDaysTheme: WheelTheme = {
  uuid: 'lucky-days-store',
  createdTs: '',
  updatedTs: '',
  name: 'Lucky Days',
  cssVariables: values({
    '--color-base-1': '#002d33',
    '--color-base-2': '#002d33',
    '--color-base-4': '#000000',
    '--color-accent-1': '#00b3cd',
    '--color-accent-2': '#01fafe',
    '--color-accent-3': '#01fafe',
    '--color-neutral': '#ffffff',
    '--color-neutral-100': '#ffffff',
    '--color-neutral-rgb': '255, 255, 255',
    '--z-wheel-outline': '#01fafe',
    '--z-wheel-outline-mobile': '#01fafe',
    '--z-wheel-outline-mobile-rgb': '1, 250, 254',
    '--z-cta-buttons-text-color': '#ffffff',
    '--z-cta-buttons-background-color': '#00b3cd',
    '--z-mobile-background-color': '#002d33',
  }),
  labels: values({
    'wheel.title': 'Spin for Rewards!',
    'wheel.subtitle': 'Spin the wheel to determine your prize. Good luck!',
    'wheel.spin': 'Spin Now',
  }),
  primaryFontRegularAsset: font('Regular'),
  primaryFontMediumAsset: font('Medium'),
  primaryFontBoldAsset: font('Bold'),
  jackpotFontAsset: font('Bold'),
  darkMode: true,
  backgroundAnimation: null,
  cornerRadiusCta: 24,
  termsAndConditions: null,
  rules: null,
  faq: null,
  secondaryCtaStyle: CTAStyles.Outline,
  clientLogoAsset: asset('wordmark.svg'),
  explainerBackgroundAsset: asset('aurora.png'),
  wheelLogoAsset: asset('wheel-logo.png'),
  lockingSymbolSoundAsset: null,
  resultNoPrizeSoundAsset: null,
  resultPrizeRevealSoundAsset: null,
  spinSoundAsset: null,
  infoBackgroundImageMobileAsset: null,
  infoBackgroundImageDesktopAsset: null,
  playBackgroundImageMobileAsset: asset('aurora.png'),
  playBackgroundImageDesktopAsset: asset('aurora.png'),
  resultsBackgroundImageMobileAsset: null,
  resultsBackgroundImageDesktopAsset: null,
  showSimplifiedPreviousResult: false,
  showInnerRing: true,
  wheelCenterBackgroundAsset: null,
  centerBackgroundShadow: false,
  textPositionInside: true,
  desktopFullResolutionFormat: false,
  zoom: 1,
};
